import { equalsArray } from "../setoid";
export function unzip(arr) {
    const acc = [];
    const bcc = [];
    arr.forEach(([a, b]) => {
        acc.push(a);
        bcc.push(b);
    });
    return [acc, bcc];
    /* Push is much faster, like over 3 times
     * return arr.reduce(
     *   (
     *     [acc, bcc]: [ Array<A>, Array<B> ],
     *     [a, b]: [A, B]
     *   ): [ A[], B[] ] => pair([a].concat(acc), [b].concat(bcc)),
     *   [ [], [] ] as [ Array<A>, Array<B> ]
     * ); */
}
// Setoid
export const equals = (a, b) => equalsArray(a, b);
// Functor
export const map = (f, as) => as.map(f);
// Applicative
export const of = (a) => [a];
// Semigroup
export const concat = (a, b) => a.concat(b);
// Monoid
export const empty = () => [];
// Chain
export const chain = (f, as) => as.flatMap(f);

